/**
 * Created by rhinov20e on 8/26/2016.
 *
 * Display the scale of the current map bottom right of the screen
 */

import { ActionStateEnum } from "../../state/actionState/ActionState";
import { PlanManager } from "../../../../cocosPlan";
import { Events, eventsManager } from "@rhinov/savane-js";


declare var cc: any;


export class ScaleIndicator extends cc.DrawNode {

    // Default class value
    fullLength: number = 0;
    mainColor: any = new cc.color('a29b92');

    constructor() {
        // @ts-ignore Drawnode cannot be constructed via super()
        super()
         // Hide the node if AbsoluteIdle otherwise display it
        if (PlanManager.getInstance().getAction() === ActionStateEnum.AbsoluteIdle) {
            this.setVisible(false);
        }
        else {
            this.setVisible(true);
        }

        // Store current zoom value from plan manager
        this.zoom = PlanManager.getInstance().getZoomScale();
        // And compute full length
        this.fullLength = 100 * this.zoom;
    }

    // Called when the object is initialised
    init () {
        this.mainColor = new cc.color('a29b92');
        // Set node anchor point
        this.setAnchorPoint(0, 0);
        if (super.init()) {
            // Create a text label size 12 pts
            this.label = new cc.LabelTTF('100 cm', 'Roboto-Light', 12, new cc.size(0, 16), cc.TEXT_ALIGNMENT_CENTER, cc.TEXT_ALIGNMENT_CENTER);
            this.label.setName('scaleLabel');
            this.label.setFontFillColor(this.mainColor);
            this.label.setAnchorPoint(new cc.p(0, 1.2));
            this.label.setColor(this.mainColor);
            this.addChild(this.label);

            return true;
        }

        return false;
    }

    /**
     * Update value of dimensions
     * @param value (cm)
     * @param zoom
     */
    /**
     * Redraw node to process new values
     */
    redraw () {
        this.clear();
        // Recompute full length to display segments below
        this.fullLength = 100 * this.zoom;

        // Draw 3 segments to display someting like a |______|
        this.drawSegment(new cc.p(0, 0), new cc.p(this.fullLength, 0), 1, this.mainColor);
        this.drawSegment(new cc.p(0, 0), new cc.p(0, 10), 1, this.mainColor);
        this.drawSegment(new cc.p(this.fullLength, 0), new cc.p(this.fullLength, 10), 1, this.mainColor);
        // And set the label position
        this.label.setPositionX((this.fullLength - this.label.getContentSize().width) * 0.5);
    }

    getFullLength () {
        return this.fullLength;
    }

    setFlipped (value: any) {
        this.label.setFlippedY(value);
        this.label.setFlippedX(value);
    }

    /**
     * Remove all attached listener
     */
    removeListeners () {
        eventsManager.instance.removeListener(this.scrollListener);
        eventsManager.instance.removeListener(this.stateListener);
    }

    // When the object is created, creat 2 listeners lisetening to :
    // Zoom change
    // Map status changed
    onEnter () {
        // Call onOnter super class
        super.onEnter();

        // Create zoom listener to update the zoom value
        this.scrollListener = eventsManager.instance.addListener(Events.ZOOM_SCROLLWIN_CHANGED, (_event: any) => {
            // Retrieve zoom value passed
            this.zoom = _event.getUserData();

            // Clear the node content and redraw it
            this.clear();
            this.redraw();

        });

        // Create map status changed
        this.stateListener = eventsManager.instance.addListener(Events.PLAN_STATE_CHANGED, (_event: any) => {
            // Check if we have entered into a state where we need to hide this node and hide or unhide it
            if (PlanManager.getInstance().getAction() === ActionStateEnum.AbsoluteIdle) {
                this.setVisible(false);
            }
            else {
                this.setVisible(true);
            }
        });
    }

    // When the object is destroyed, remove the listeners created above
    onExit () {
        // Call the super class exit function
        super.onExit();
        // And remove the listeners
        this.removeListeners();
    }

    
}
